import { render, staticRenderFns } from "./ExerciseRightSidebar.vue?vue&type=template&id=6732651a&scoped=true&"
import script from "./ExerciseRightSidebar.vue?vue&type=script&lang=js&"
export * from "./ExerciseRightSidebar.vue?vue&type=script&lang=js&"
import style0 from "./ExerciseRightSidebar.vue?vue&type=style&index=0&id=6732651a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6732651a",
  null
  
)

export default component.exports